import { FormikErrors, FormikTouched, FormikValues, useFormik } from 'formik';
import { classNames } from 'primereact/utils';
import { useContext, useEffect, useState } from 'react';
import { InterfaceInput } from '../../../../interfaces/interfaces';

import { ButtonComponent } from '../../../../components/ButtonComponen';
import { InputComponent } from '../../../../components/InputComponent';
import { StoreContext } from '../../../../context/Provider';

import { useEditSam } from '../../../../hooks/inventory/useEditSam';
import { IStations } from '../../../../interfaces/interfaceCatalogs';
import { IEditSam } from '../../../../interfaces/interfaceSamData';

import {
  ICoordinates,
  eliminarNull,
  getCurrentPosition,
} from '../../../../utils/utils';

import { DropdownComponent } from '../../../../components/DropdownComponen';
import { DropdownChangeEvent } from 'primereact/dropdown';
import {
  initialValuesInventoryFormik,
  validationSchemaInventory,
} from '../../../../interfaces/interfacesDeviceTypeForms';
import { locationPermissionService } from '../../../../services/locationPermissionService';

interface IInputForm {
  typedName:
    | 'IdSocket'
    | 'Address'
    | 'NumberDevice'
    | 'CarPlates'
    | 'EconomicNumber'
    | 'RouteName'
    | 'Observations'
    | 'Station'
    | 'Project'
    | 'TechnologicalOperator'
    | 'DeviceType'
    | 'LocationId';
}

export type IRenderInput = InterfaceInput & IInputForm;

export const EditSamMenu = (props: IEditSam) => {
  let RowData = props.row;
  const { setOpenRightMenu, updateTable } = props;

  const [economicNumbers, setEconomicNumbers] = useState<any>([]);
  const [stations, setStations] = useState<IStations[]>([]);
  const [locations, setLocations] = useState<any[]>([]);

  const [pos, setPos] = useState<any>([]);
  const [routes, setRoutes] = useState<any>([]);

  const { putEditSam } = useEditSam();

  const {
    getEconomicNumbersCatalogState,
    getRoutesCatalogState,
    getStationsCatalogState,
    getPointsOfSalesCatalogState,
  } = useContext(StoreContext);

  const close = () => {
    setOpenRightMenu(false);
  };

  useEffect(() => {
    formik.setValues(RowData);
  }, []);

  useEffect(() => {
    if (getPointsOfSalesCatalogState.state.data !== null) {
      const { data } = getPointsOfSalesCatalogState.state;
      setPos(data);
    }
  }, [getPointsOfSalesCatalogState.state]);

  useEffect(() => {
    if (getStationsCatalogState.state.data !== null) {
      const { data } = getStationsCatalogState.state;

      setStations(data);
      if (RowData.StationId) {
        const selectedStation = data.find(
          (station: IStations) => station.id === RowData.StationId
        );

        setLocations(selectedStation?.locations || []);
      }
    }
  }, [getStationsCatalogState.state]);

  useEffect(() => {
    if (getEconomicNumbersCatalogState.state.data !== null) {
      const { data } = getEconomicNumbersCatalogState.state;
      setEconomicNumbers(data);
    }
  }, [getEconomicNumbersCatalogState.state]);

  useEffect(() => {
    if (getRoutesCatalogState.state.data !== null) {
      const { data } = getRoutesCatalogState.state;
      setRoutes(data);
    }
  }, [getRoutesCatalogState.state]);

  const addIdsToDevice = (device: any): any => {
    const route = routes.find((route: any) => route.name === device.RouteName);

    const economic = economicNumbers.find(
      (economic: any) => economic.economicNumber === device.EconomicNumber
    );

    const selectedLocation = locations.find(
      (location: any) => location.locationId === device.LocationId
    );

    return {
      ...device,
      routeId: route?.routeId,
      economicNumberId: economic?.economicNumberId,
      LocationId: selectedLocation?.id,
    };
  };

  const handleSubmit = async (values: any) => {
    const addedRouteId = addIdsToDevice(values);
    let coords: ICoordinates =
      await locationPermissionService.getCurrentCoordinates();
    const headers = {
      locationGPS: `${coords?.latitude}, ${coords?.latitude}`,
      appId: 'web',
    };
    await putEditSam(addedRouteId, headers);
    updateTable();
  };

  const formik = useFormik({
    initialValues: initialValuesInventoryFormik,
    validationSchema: validationSchemaInventory,
    enableReinitialize: true,
    // validate: (data: any) => {
    //   const errors: any = {};
    //   return errors;
    // },
    onSubmit: data => {
      //setFormData(data);
      //  setShowMessage(true);
      handleSubmit(data);
    },
  });

  function isFormFieldValid(
    name: string,
    errors: FormikErrors<FormikValues>,
    touched: FormikTouched<FormikValues>
  ) {
    return !!(touched[name] && errors[name]);
  }

  function getFormErrorMessage(
    name: string,
    errors: FormikErrors<FormikValues>,
    touched: FormikTouched<FormikValues>
  ) {
    const error = errors[name];
    const errorMessage = typeof error === 'string' ? error : '';
    return (
      isFormFieldValid(name, errors, touched) && (
        <small className="p-error">{errorMessage}</small>
      )
    );
  }

  const renderInput = (props: IRenderInput) => {
    return (
      <div className="flex flex-col mt-3">
        <InputComponent
          disabled={props.disabled}
          label={props.label}
          type={props.type}
          name={props.name}
          onChange={formik.handleChange}
          value={formik?.values?.[props.typedName] || ''}
          //className="rounded-sm border border-gray-800 border-opacity-20 px-1.5 py-0.5 mt-2 mb-7 w-full"
          className={classNames({
            'p-invalid': isFormFieldValid(
              props.typedName,
              formik.errors,
              formik.touched
            ),
          })}
          placeholder={props.placeholder}
          maxLength={props.max}
        />
        {getFormErrorMessage(props.typedName, formik.errors, formik.touched)}
      </div>
    );
  };
  const renderTextArea = (props: IRenderInput) => {
    return (
      <div className="flex flex-col mt-3 mb-3">
        <label htmlFor="reasonInput" className="font-bold text-grey">
          {props.label}
        </label>
        <textarea
          id="reasonInput"
          className="border border-grey rounded-md p-2 mt-2 resize-none"
          placeholder={props.label}
          value={formik?.values?.[props.typedName] || ''}
          name={props.name}
          rows={3}
          onChange={formik.handleChange}
        />

        {getFormErrorMessage(props.typedName, formik.errors, formik.touched)}
      </div>
    );
  };

  const renderTextValue = (value: string, label: string) => {
    return (
      <div className="flex flex-col w-full  my-2 ">
        <label htmlFor="samType" className="font-bold text-grey">
          {label}
        </label>
        <span
          id="samType"
          className="truncate max-w-full ms-3 ml-2"
          title={value}>
          {value}
        </span>
      </div>
    );
  };

  function onHandleChangeStation(e: DropdownChangeEvent) {
    // e puede ser el valor seleccionado directamente o un objeto dependiendo del componente
    const selectedValue = e?.value ?? e; // asegúrate cómo lo emite tu DropdownComponent

    const selectedStation = stations.find(
      (station: IStations) => station.id === selectedValue
    );

    setLocations(selectedStation?.locations || []);
    // Guardamos en formik
    formik.setFieldValue('StationId', selectedValue);
  }

  function onSelectLocation(e: string) {
    const selectedLocation = locations.find(
      (location: any) => location.locationId === e
    );

    return selectedLocation !== undefined ? selectedLocation.id : '';
  }

  function onHandleChangeLocation(e: DropdownChangeEvent) {
    const selectedStation = locations.find(
      (station: IStations) => station.id === e?.value
    );

    //setLocations(selectedStation?.locations || []);
    // Guardamos en formik
    formik.setFieldValue('LocationId', selectedStation.locationId);
  }

  return (
    <form
      className="flex w-full h-full mx-2  flex-col content-center  overflow-hidden"
      onSubmit={formik.handleSubmit}>
      <div className="flex w-full h-full flex-col overflow-auto border-b border-gray-200 ">
        {renderTextValue(RowData?.SamId || '', 'Id Sam')}
        {renderTextValue(RowData?.Project || '', 'Proyecto')}
        {renderTextValue(RowData?.SamType || '', 'Tipo de SAM')}
        {renderTextValue(RowData?.DeviceType || '', 'Tipo Dispositivo')}
        {renderInput({
          label: 'Id Lector',
          type: 'text',
          name: 'NumberDevice',
          typedName: 'NumberDevice',
          placeholder: 'Id Lector',
          max: 10,
        })}
        {[1, 2, 3, 6, 7].includes(RowData?.DeviceTypeEnum) && (
          <>
            <div className="flex flex-col mt-3">
              <DropdownComponent
                label={'Estación'}
                options={stations}
                optionLabel={'name'}
                name="StationId"
                optionValue={'id'}
                className="h-12 !w-full"
                value={formik?.values?.StationId || ''}
                onChange={onHandleChangeStation}
              />
            </div>
            <div className="flex flex-col mt-3">
              <DropdownComponent
                label={'Location Id'}
                options={locations}
                optionLabel={'locationId'}
                name="LocationId"
                optionValue={'id'}
                className="h-12 !w-full"
                onChange={onHandleChangeLocation}
                value={onSelectLocation(formik?.values?.LocationId || '')}
              />
            </div>
          </>
        )}
        {[4, 5].includes(RowData?.DeviceTypeEnum) && (
          <>
            <DropdownComponent
              label="Ruta"
              options={routes}
              optionLabel="name"
              name="RouteId"
              optionValue="routeId"
              onChange={formik.handleChange}
              value={formik.values?.RouteId ?? ''}
            />
          </>
        )}
        {[7].includes(RowData?.DeviceTypeEnum) && (
          <>
            <DropdownComponent
              label={'Punto de venta'}
              options={pos}
              optionLabel={'name'}
              name="PointOfSaleId"
              optionValue={'id'}
              onChange={formik.handleChange}
              value={formik?.values?.['PointOfSaleId'] || ''}
            />
          </>
        )}
        {[6, 7].includes(RowData?.DeviceTypeEnum) && (
          <>
            {renderInput({
              label: 'Dirección',
              type: 'text',
              name: 'Address',
              typedName: 'Address',
              placeholder: 'Dirección',
              //    max: 10,
            })}
          </>
        )}
        {[4, 5].includes(RowData?.DeviceTypeEnum) && (
          <>
            <DropdownComponent
              label={'Vehículo'}
              options={economicNumbers}
              optionLabel={'economicNumber'}
              name="EconomicNumberId"
              optionValue={'economicNumberId'}
              onChange={formik.handleChange}
              value={formik?.values?.['EconomicNumberId'] || ''}
            />
          </>
        )}
        {[4, 5].includes(RowData?.DeviceTypeEnum) && (
          <>
            {renderInput({
              label: 'Numero de placas',
              type: 'text',
              name: 'CarPlates',
              typedName: 'CarPlates',
              placeholder: 'Numero de placas',
              //    max: 10,
            })}
          </>
        )}
        {renderTextArea({
          label: 'Observaciones',
          type: 'text',
          name: 'Observations',
          typedName: 'Observations',
          placeholder: 'Observaciones',
        })}
      </div>
      <div className="flex justify-center my-5">
        <ButtonComponent
          name="Cancelar"
          label="Cancelar"
          className="  !bg-alternative_green !text-white border-none !rounded-3xl  mt-8 px-6 py-2 !mx-2"
          type="button"
          onClick={close}
        />
        <ButtonComponent
          name="Actualizar"
          label="Actualizar"
          className=" !bg-alternative_green border-none !rounded-3xl   text-white mt-8 px-6 py-2 !mx-2"
          type="submit"
        />
      </div>
    </form>
  );
};
